// extracted by mini-css-extract-plugin
module.exports = {"li":"Event_li__HdXtH","marque":"Event_marque__398ej","example1":"Event_example1__6lSmd","screen":"Event_screen__pTRhn"};